import React from 'react'
import PropTypes from 'prop-types'

import { Grid } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './GroupDetailModuleContainer'
import Enhancer from './GroupDetailModuleEnhancer'
import StandardError from 'Components/StandardError'
import StandardLoader from 'Components/StandardLoader'
import { withPermissions } from 'Components/Permissions'

import GroupCard from 'Components/GroupCard'
import GroupPermissionsSection from 'Components/GroupPermissionsSection'

const GroupDetailModule = ({ group, handleDelete, handleNameSet, handlePermissionsSet }) => {
  if (!group.id) {
    return null
  }

  return (
    <Grid>
      <Grid.Row columns={1}>
        <Grid.Column width={4}>
          <GroupCard group={group} handleDelete={handleDelete} handleNameSet={handleNameSet} />
        </Grid.Column>

        <Grid.Column width={12}>
          <GroupPermissionsSection group={group} handleNameSet={handleNameSet} handlePermissionsSet={handlePermissionsSet} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

GroupDetailModule.propTypes = {
  group: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleNameSet: PropTypes.func.isRequired,
  handlePermissionsSet: PropTypes.func.isRequired,
}

const composed = compose(
  withPermissions('modules.groups'),
  Enhancer,
  Container,
  StandardLoader('Completing group assignment…'),
  StandardError,
)

export default composed(GroupDetailModule)
